function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 5,
  width: 60,
  height: 90,
  fill: "transparent",
  stroke: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 27,
  y: 35,
  width: 4,
  height: 30
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 27,
  y: 15,
  width: 5,
  height: 1
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 15,
  width: 5,
  height: 1
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 67,
  y: 15,
  width: 5,
  height: 1
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 37,
  y: 25,
  width: 5,
  height: 1
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 57,
  y: 25,
  width: 5,
  height: 1
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 35,
  width: 5,
  height: 1
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 67,
  y: 35,
  width: 5,
  height: 1
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 37,
  y: 45,
  width: 5,
  height: 1
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 57,
  y: 45,
  width: 5,
  height: 1
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 55,
  width: 5,
  height: 1
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 67,
  y: 55,
  width: 5,
  height: 1
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 37,
  y: 65,
  width: 5,
  height: 1
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 57,
  y: 65,
  width: 5,
  height: 1
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 27,
  y: 75,
  width: 5,
  height: 1
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 75,
  width: 5,
  height: 1
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 67,
  y: 75,
  width: 5,
  height: 1
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 37,
  y: 85,
  width: 5,
  height: 1
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 57,
  y: 85,
  width: 5,
  height: 1
});

function SvgShakerDoor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShakerDoor);
export default __webpack_public_path__ + "static/media/shakerDoor.88fabaef.svg";
export { ForwardRef as ReactComponent };